(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((d) => d.close());
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal && this.searchModal.close(false);
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["titan-max-scroll-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smoothstep = (start, end, value) => {
      const progress = clamp((value - start) / (end - start));
      return progress * progress * (3 - 2 * progress);
    };
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const mobileQuery = window.matchMedia("(max-width: 820px)");
    const instances = new WeakMap();

    const setup = (story) => {
      if (instances.has(story)) return;

      const chapters = [...story.querySelectorAll("[data-titan-chapter]")];
      let target = 0;
      let frame = 0;
      let lastNearest = -1;
      let lastPaint = -1;

      const paint = (position) => {
        const mobile = mobileQuery.matches;
        // Mobil: snap — ara frame opacity/transform yağmurunu kes
        const pos = mobile ? Math.round(position) : position;
        if (mobile && pos === lastPaint) return;
        lastPaint = mobile ? pos : position;

        const nearest = Math.round(pos);
        const travel = mobile ? 28 : 72;

        chapters.forEach((chapter, index) => {
          const distance = index - pos;
          const direction = distance < 0 ? -1 : 1;
          const phase = mobile
            ? index === nearest
              ? 0
              : 1
            : smoothstep(0.06, 0.42, Math.abs(distance));
          const opacity = 1 - phase;
          const y = direction * phase * travel;
          chapter.style.opacity = String(opacity);
          chapter.style.transform = opacity > 0.01 ? `translate3d(0, ${y}px, 0)` : "translate3d(0, 0, 0)";
          if (nearest !== lastNearest) {
            chapter.setAttribute("aria-hidden", index === nearest ? "false" : "true");
          }
        });
        lastNearest = nearest;
      };

      const read = () => {
        const rect = story.getBoundingClientRect();
        const scrollable = Math.max(1, story.offsetHeight - window.innerHeight);
        const raw = clamp(-rect.top / scrollable);
        // Mobil: kısa giriş payı — chapter 0 bir an sabit, sonra snap
        const progress = mobileQuery.matches
          ? clamp((raw - 0.12) / 0.88)
          : raw;
        target = progress * (chapters.length - 1);
      };

      const update = () => {
        if (reducedMotion.matches) return;
        read();
        if (!frame) {
          frame = requestAnimationFrame(() => {
            frame = 0;
            paint(target);
          });
        }
      };

      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      reducedMotion.addEventListener("change", update);
      mobileQuery.addEventListener("change", update);
      update();
      instances.set(story, { update });
    };

    const setupAll = (root = document) => {
      root.querySelectorAll("[data-titan-scroll-hero]").forEach(setup);
    };

    setupAll();
    document.addEventListener("shopify:section:load", (event) => setupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
